<template>
  <v-container grid-list-xs class="pa-0 ma-0" fluid>
    <v-row class="pa-0 ma-0 titlesdark--text">
      <v-col cols="12">
        <v-card
          color="grey lighten-2"
        >
          <v-card-title>
            <span class="text-primary text-medium">{{$store.state.jsIdioma.oEquivalencias.ttlIntegracionOddo}}</span>
          </v-card-title>
          <v-card-text>
            <v-col cols="12" class="py-0 my-3">
                <v-text-field
                    hide-details
                    :label="$store.state.jsIdioma.oEquivalencias.cmpNitCliente"
                    outlined
                    prepend-inner-icon="mdi-magnify"
                    type="number"
                    v-model="nBusquedadNIT"
                    @keyup.enter="buscarNIT()"
                ></v-text-field>
            </v-col>
            <v-col cols="12" class="d-flex justify-center my-0 py-0">
                <v-btn
                  color="btndest"
                  dark
                  @click="buscarNIT()">
                  <v-icon left>
                      mdi-magnify
                  </v-icon>
                      {{$store.state.jsIdioma.oEquivalencias.btnBuscar}}
                  </v-btn>
            </v-col>
          </v-card-text>
        </v-card>
      </v-col>

      <v-col cols="12">
        <span class="text-primary font-size-2 text-medium">{{$store.state.jsIdioma.oEquivalencias.stlDetalleInformacion}}</span>
      </v-col>

      <v-col cols="12" v-if="oResultadoNIT.NIT!=null">
        <v-card
          color="grey lighten-2"
        >
          <v-card-text>
            <span class="text-primary text-medium">{{$store.state.jsIdioma.oEquivalencias.lbNit}}</span>
            <p>{{oResultadoNIT.NIT}}</p>
            <span class="text-primary text-medium">{{$store.state.jsIdioma.oEquivalencias.lbCliente}}</span>
            <p>
                {{oResultadoNIT.nombre}}
            </p>
            <v-row class="d-flex flex-row-reverse">
                <v-btn
                  @click="cargarDetalle()"
                  color="btndest"
                  dark
                >
                  <v-icon left>
                    mdi-eye
                  </v-icon>
                  {{$store.state.jsIdioma.oEquivalencias.btnDetalle}}
              </v-btn>
            </v-row>
          </v-card-text>
        </v-card>
      </v-col>

    </v-row>
    
    <!-- modal para mostrar el detallado -->
    <v-dialog
      v-model="bModalDetallado"
      scrollable
      max-width="800px"
    >
      <v-card >
        <v-toolbar
            color="headformsdark"
            height="45"
            elevation="0"
            dense
            dark>
            <v-col cols="6">
                <h3>{{$store.state.jsIdioma.oEquivalencias.stlDetalleInformacion}}</h3>
            </v-col>
            <v-col cols="6" class="d-flex flex-row-reverse">
                <v-btn 
                  @click="bModalDetallado=false"
                  icon
                  small
                  dark
                  outlined>
                  <v-icon size="14px">fa fa-times</v-icon>
                </v-btn>
            </v-col>
        </v-toolbar>
        <v-divider></v-divider>

        <v-card-title class="d-flex justify-center">{{$store.state.jsIdioma.oEquivalencias.stlOrdenActiva}}</v-card-title>
        <v-divider></v-divider>
        <v-card-text>
          <v-row>
            <v-row>
              <v-col>
                <v-icon size="14px" class="mr-3" color="green">fa fa-check</v-icon>
                {{$store.state.jsIdioma.oEquivalencias.lblSinNovedad}}
              </v-col>

              <v-col>
                <v-icon size="14px" class="mr-3" color="yellow">fa fa-exclamation-triangle</v-icon>
                {{$store.state.jsIdioma.oEquivalencias.lblNovedadPuesto}}
              </v-col>

              <v-col>
                <v-icon size="14px" class="mr-3" color="red">fa fa-times-circle</v-icon>
                {{$store.state.jsIdioma.oEquivalencias.lblNovedadSede}}
              </v-col>
            </v-row>

            <v-col cols="12">
              <v-card
                color="grey lighten-2"
              >
                <v-col cols="12">
                  <span class="text-primary text-medium">{{$store.state.jsIdioma.oEquivalencias.lbNit}}</span>
                  <p>{{oResultadoNIT.NIT}}</p>
                  <span class="text-primary text-medium">{{$store.state.jsIdioma.oEquivalencias.lbCliente}}</span>
                  <p>
                      {{oResultadoNIT.nombre}}
                  </p>
                </v-col>
              </v-card>
            </v-col>

            <v-col cols="12">
              <h2>{{$store.state.jsIdioma.oEquivalencias.sede}}</h2>

              <v-expansion-panels class="mt-4" v-if="aSedesResultado.length>0">
                <v-expansion-panel
                  v-for="(sede,i) in aSedesResultado"
                  :key="i"
                >
                  <v-expansion-panel-header>
                    <v-row class="d-flexd-inline-flexs">
                      <v-icon size="14px" class="mr-3" color="red" v-if="sede.con_novedad==1">fa fa-times-circle</v-icon>
                      <v-icon size="14px" class="mr-3" color="yellow" v-else-if="sede.bNovedadPuesto">fa fa-exclamation-triangle</v-icon>
                      <v-icon size="14px" class="mr-3" color="green" v-else>fa fa-check</v-icon>
                      {{sede.Sede}}
                    </v-row>
                  </v-expansion-panel-header>
                  <v-expansion-panel-content>
                    <v-col v-if="sede.aPuestos.length > 0">
                      <v-alert
                        elevation="2"
                        v-for="(puesto,j) in sede.aPuestos"
                        :key="j"
                      >
                        <v-icon size="14px" class="mr-3" color="yellow" v-if="puesto.orden_valida==0">fa fa-exclamation-triangle</v-icon>
                        {{puesto.Puesto}}
                      </v-alert>
                    </v-col>
                    <p v-else class="mt-2">
                      {{$store.state.jsIdioma.oEquivalencias.lblSinInformacion}}
                    </p>
                  </v-expansion-panel-content>
                </v-expansion-panel>
              </v-expansion-panels>
              <p v-else class="mt-2">
                {{$store.state.jsIdioma.oEquivalencias.lblSinInformacion}}
              </p>
              
            </v-col>
          </v-row>
        </v-card-text>
      </v-card>
    </v-dialog>
    <!-- modal para mostrar el detallado -->

  </v-container>
</template>

<script>
import mxFunciones from '@/mixins/funciones.js'
import axiosServices from '@/services/axiosServices.js'

export default {
  name: 'IntegracionODDO',
  mixins: [mxFunciones],
  data() {
    return {
        bModalDetallado:false,
        nBusquedadNIT:null,
        aSedesResultado:[],
        oResultadoNIT:{
            NIT:null,
            cliente:'Cliente'
        },
    }
  },
  async mounted() {
  },
  methods: {
    async buscarNIT(){

      //vaciar variables
      this.aSedesResultado=[];
      this.oResultadoNIT={
          NIT:null,
          cliente:'Cliente'
      };
      if(this.nBusquedadNIT==null||this.nBusquedadNIT==''){
          this.$store.dispatch('notificaciones/SetMensaje', `Campo vacío`);
          this.$store.dispatch('notificaciones/ShowNotificacion', true);
          this.$store.dispatch('notificaciones/SetColor','error')
          return;
      }

      axiosServices.getConfiguration("/integracion_oddo/validacion/"+this.nBusquedadNIT, true)
      .then(oResponse => {
          this.$store.dispatch('notificaciones/ShowNotificacion', false);

          if(oResponse.sStatus == 'error'){
            this.$store.dispatch('notificaciones/SetMensaje', oResponse.sMessage);
            this.$store.dispatch('notificaciones/ShowNotificacion', true);
            this.$store.dispatch('notificaciones/SetColor','error')
          }
          else if(oResponse.sStatus == 'success'){
            this.oResultadoNIT = oResponse.aData.aInfoCliente[0]

            //buscar si el puesto tiene alguna novedad
            this.aSedesResultado = oResponse.aData.aSedes

            for (let i = 0; i < this.aSedesResultado.length; i++) {
              let oResulNovedad = this.aSedesResultado[i].aPuestos.find(item=> item.orden_valida==0)
              if(oResulNovedad!=undefined){
                this.aSedesResultado[i].bNovedadPuesto=true;
              }
              else{
                this.aSedesResultado[i].bNovedadPuesto=false;
              }
            }
            
          }
          //console.log(oResponse)
        });
    },
    cargarDetalle() {
        this.bModalDetallado=true
    }
  },
}
</script>

<style lang="scss" scoped>

</style>